import { DisplayMode } from '@r-core';

import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const rotateDimensionMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Rotate 90°',
		displayModes: [
			DisplayMode.Overhead,
			DisplayMode.OverheadManufacturing,
			DisplayMode.SkuOverhead,
			DisplayMode.SkuOverheadManufacturing,
			DisplayMode.Panel,
			DisplayMode.Inline,
			DisplayMode.InlineManufacturing,
			DisplayMode.Manufacturing
		],
		isVisible: ({ context, controller }): boolean => {
			if (controller.readonly) return false;
			const dimensionId = context?.id ?? null;
			if (!dimensionId) return false;
			const dimension = controller.kitchen.design.dimensions.children.find((d) => d.id === dimensionId);
			return dimension != null;
		},
		onClick: ({ context, controller }): void => {
			const dimensionId = context?.id ?? null;

			if (dimensionId) {
				const dimension = controller.kitchen.design.dimensions.children.find((d) => d.id === dimensionId);
				if (dimension) {
					dimension.rotate90();
				}
			}
		}
	};
};
